module.exports = __webpack_public_path__ + "static/media/factory_robot_arm.6eb64912.usdz";